import { PropsWithChildren, useEffect } from 'react';

import { css, Global } from '@emotion/react';

import { CloseIcon } from '../Icon';
import { PortalContainer } from '../PortalContainer';
import { ModalBaseProps } from '../types/modal';
import * as S from './style';

// import Close from '~components/Icon/Close';

export default function ModalBase({
  children,
  inlineCss,
  isOpen,
  handleClose,
  maskClosable = true,
  hasCloseButton = true,
  isFullSize = false,
  isBlur = false,
}: PropsWithChildren<ModalBaseProps>) {
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        event.preventDefault();
        handleClose();
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  const handleClickBackground = () => {
    if (maskClosable) {
      handleClose();
    }
  };

  if (!isOpen) {
    return null;
  }

  return (
    <PortalContainer className="modalContainer">
      <Global
        styles={css`
          body {
            overflow: hidden;
          }
        `}
      />
      <S.Wrapper>
        <S.Background onClick={handleClickBackground} isBlur={isBlur} />
        <S.ModalContent inlineCss={inlineCss} isFullSize={isFullSize}>
          {hasCloseButton && (
            <S.ButtonClose onClick={() => handleClose()}>
              <CloseIcon width={20} height={20} />
            </S.ButtonClose>
          )}
          {children}
        </S.ModalContent>
      </S.Wrapper>
    </PortalContainer>
  );
}

export function BottomSheetBase({
  children,
  isOpen,
  handleClose,
  maskClosable = true,
  hasCloseButton = true,
  isBlur = false,
}: PropsWithChildren<ModalBaseProps>) {
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        event.preventDefault();
        handleClose();
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  const handleClickBackground = () => {
    if (maskClosable) {
      handleClose();
    }
  };

  if (!isOpen) {
    return null;
  }

  return (
    <PortalContainer className="modalContainer">
      <Global
        styles={css`
          body {
            overflow: hidden;
          }
        `}
      />
      <S.Wrapper>
        <S.Background onClick={handleClickBackground} isBlur={isBlur} />
        <S.BottomsheetContent>
          {hasCloseButton && (
            <S.ButtonClose onClick={() => handleClose()}>
              <CloseIcon width={20} height={20} />
            </S.ButtonClose>
          )}
          {children}
        </S.BottomsheetContent>
      </S.Wrapper>
    </PortalContainer>
  );
}
